import React, { memo, useCallback, useMemo } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { FlashList } from '@shopify/flash-list';
import { useAppSelector } from 'store/hooks';
import { AppView, SCREEN_BOTTOM_PADDING, withAnimatedNavigationHeader } from 'design-system';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import Pot from 'features/pots/components/Pot';
import { isWeb } from '../../../constants';
const subtitle = 'These are pots you have closed in the past. We keep them here so you can check their activity or unarchive them at any time.';
const AnimatedFlashList = Animated.createAnimatedComponent(FlashList);
const ArchivedPotsScreen = withAnimatedNavigationHeader(({ scrollHandler }) => {
    const archivedPots = useAppSelector((state) => state.pots.deletedPots);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    const keyExtractor = useCallback((item) => item.id, []);
    const onRenderItem = useCallback(({ item, index }) => (<Pot data={item} isFirstItem={index === 0} isLastInSection={index === (archivedPots?.length || 0) - 1}/>), [archivedPots?.length]);
    const listHeader = useMemo(() => (<View style={styles.header}>
          <Text TextThin-16 Secondary>
            {subtitle}
          </Text>
        </View>), []);
    return (<AppView withFrame={false}>
        <AnimatedFlashList data={archivedPots} renderItem={onRenderItem} keyExtractor={keyExtractor} ListHeaderComponent={listHeader} onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={contentContainerStyle}/>
      </AppView>);
}, ({ colors }) => ({
    title: 'Archived pots',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = { header: { marginHorizontal: rem(16), marginBottom: rem(24), marginTop: rem(16) } };
export default memo(ArchivedPotsScreen);
